export default {"src":"/_next/static/media/assumptions3.0ce36e00.svg","height":440,"width":640};